import { render, staticRenderFns } from "./ShareButtons.vue?vue&type=template&id=34161732&"
import script from "./ShareButtons.vue?vue&type=script&lang=ts&"
export * from "./ShareButtons.vue?vue&type=script&lang=ts&"
import style0 from "./ShareButtons.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports